import { Matrix34 } from '@seddi/math-v2';
import { Matrix4 } from '@seddi/three';

export class ThreeMatrix4 {
  static CopyFrom34(this_: Matrix4, other: Matrix34) {
    const src = other.m;
    const dst = this_.elements;
    dst[0] = src[0];
    dst[1] = src[1];
    dst[2] = src[2];
    dst[3] = 0;
    dst[4] = src[3];
    dst[5] = src[4];
    dst[6] = src[5];
    dst[7] = 0;
    dst[8] = src[6];
    dst[9] = src[7];
    dst[10] = src[8];
    dst[11] = 0;
    dst[12] = src[9];
    dst[13] = src[10];
    dst[14] = src[11];
    dst[15] = 1;
  }
}
